var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-multi-select-tabs-container"},[_c('ul',{staticClass:"nav nav-tabs",class:{
      'nav-tabs-assignments': _vm.sector === 'assignments' && _vm.expand,
      'nav-tabs-assignments-without-ex': _vm.sector === 'assignments' && !_vm.expand
    },staticStyle:{"border-bottom":"0"}},[_vm._l((_vm.tabs),function(tab,tabIndex){return _c('li',{key:tabIndex,class:{
        active: _vm.selected.toLowerCase() === tab.alias.toLowerCase(),
        fLeft: _vm.expandToRight,
        'fLeft-sms': _vm.sector === 'sms',
        fRight: !_vm.expandToRight && _vm.sector !== 'countries',
        'fRight-countries': _vm.sector === 'countries',
        'fRight-na': _vm.sector === 'no_answer',
        'fRight-tr': _vm.sector === 'transfer',
        'fRight-rf': _vm.sector === 'referral',
        'fRight-ld': _vm.sector === 'leads',
        'fRight-dp': _vm.sector === 'deposits',
        'fRight-assign': _vm.sector === 'assignments'
      },staticStyle:{"font-weight":"900"},on:{"click":function($event){return _vm.setTab(tab)}}},[_c('a',{class:{ hideItForNow: tab.name === 'Auto Status' },style:(_vm.background.mainBg),attrs:{"href":"javascript:void(0)"}},[_vm._v(_vm._s(tab.name))])])}),(_vm.sector === 'countries')?_c('li',{staticClass:"for-matrix"},[_c('a',{style:(_vm.background.mainBg),on:{"click":function($event){[
            _vm.$store.commit('clients/setClickedOnMatrixCountries', true),
            _vm.$emit('closeIt', false)
          ]}}},[_vm._v("MATRIX")])]):_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }